import { i18n } from '../../translations'
import RouteParam from '@/enums/RouteParam'
import type { Route } from '@/types/Route'

import AccessibilityPage from '@/components/pages/AccessibilityPage.vue'
import CollectionTaskPage from '@/components/pages/CollectionTaskPage.vue'
import ContentRightsPage from '@/components/pages/ContentRightsPage.vue'
import DesignPage from '@/components/pages/DesignPage.vue'
import FeidePage from '@/components/pages/FeidePage.vue'
import HomePage from '@/components/pages/HomePage.vue'
import NotFoundPage from '@/components/pages/NotFoundPage.vue'
import PrivacyPage from '@/components/pages/PrivacyPage.vue'
import ResourceGuidePage from '@/components/pages/ResourceGuidePage.vue'
import SubjectContentPage from '@/components/pages/SubjectContentPage.vue'
import SubjectGuidePage from '@/components/pages/SubjectGuidePage.vue'
import SubjectPage from '@/components/pages/SubjectPage.vue'
import SubjectResourcePage from '@/components/pages/SubjectResourcePage.vue'
import TeacherResourcesPage from '@/components/pages/TeacherResourcesPage.vue'
import TopicGuidePage from '@/components/pages/TopicGuidePage.vue'
import TopicPage from '@/components/pages/TopicPage.vue'

const { t } = i18n.global

export const Routes: Record<string, Route> = Object.freeze({
  Home: {
    name: 'Home',
    path: '/',
    component: HomePage,
    meta: { title: t('home.welcome') },
  },
  Feide: {
    name: 'Feide',
    path: '/feide',
    component: FeidePage,
    meta: { title: 'Feide' }
  },
  Subject: {
    name: 'Fag',
    path: `/fag/:${RouteParam.Subject}`,
    param: RouteParam.Subject,
    component: SubjectPage,
    meta: { requiresAuth: true }
  },
  SubjectGuide: {
    name: 'Fagveiledning',
    path: `/fag/:${RouteParam.Subject}/laererveiledning/:${RouteParam.SubjectGuide}`,
    param: RouteParam.SubjectGuide,
    component: SubjectGuidePage,
    meta: { requiresAuth: true }
  },
  Topic: {
    name: 'Tema',
    path: `/fag/:${RouteParam.Subject}/tema/:${RouteParam.Topic}`,
    param: RouteParam.Topic,
    component: TopicPage,
    meta: { requiresAuth: true }
  },
  TopicGuide: {
    name: 'Temaveiledning',
    path: `/fag/:${RouteParam.Subject}/tema/:${RouteParam.Topic}/laererveiledning/:${RouteParam.TopicGuide}`,
    param: RouteParam.TopicGuide,
    component: TopicGuidePage,
    meta: { requiresAuth: true }
  },
  TeacherResourceBank: {
    name: 'Ressursbank',
    path: `/fag/:${RouteParam.Subject}/tema/:${RouteParam.Topic}/ressursbank`,
    param: RouteParam.Topic,
    component: TeacherResourcesPage,
    meta: { requiresAuth: true }
  },
  TeacherResourceBankSubjectResource: {
    name: 'RessursbankFagressurs',
    path: `/fag/:${RouteParam.Subject}/tema/:${RouteParam.Topic}/ressursbank/fagressurs/:${RouteParam.SubjectResource}`,
    param: RouteParam.SubjectResource,
    component: SubjectResourcePage,
    meta: { requiresAuth: true }
  },
  TeacherResourceBankResourceGuide: {
    name: 'RessursbankRessursveiledning',
    path: `/fag/:${RouteParam.Subject}/tema/:${RouteParam.Topic}/ressursbank/fagressurs/:${RouteParam.SubjectResource}/laererveiledning/:${RouteParam.ResourceGuide}`,
    param: RouteParam.ResourceGuide,
    component: ResourceGuidePage,
    meta: { requiresAuth: true }
  },
  SubjectContent: {
    name: 'Fagtekst',
    path: `/fag/:${RouteParam.Subject}/tema/:${RouteParam.Topic}/fagtekst/:${RouteParam.SubjectContent}`,
    param: RouteParam.SubjectContent,
    component: SubjectContentPage,
    meta: { requiresAuth: true }
  },
  SubjectContentResourceGuide: {
    name: 'Ressursveiledning for fagstoff',
    path: `/fag/:${RouteParam.Subject}/tema/:${RouteParam.Topic}/fagtekst/:${RouteParam.SubjectContent}/laererveiledning/:${RouteParam.ResourceGuide}`,
    param: RouteParam.ResourceGuide,
    component: ResourceGuidePage,
    meta: { requiresAuth: true }
  },
  CollectionTask: {
    name: 'Oppgave',
    path: `/fag/:${RouteParam.Subject}/tema/:${RouteParam.Topic}/fagressurs/:${RouteParam.SubjectResource}/collectiontask/:${RouteParam.CollectionTask}`,
    param: RouteParam.CollectionTask,
    component: CollectionTaskPage,
    meta: { requiresAuth: true },
  },
  SubjectResource: {
    name: 'Fagressurs',
    path: `/fag/:${RouteParam.Subject}/tema/:${RouteParam.Topic}/fagressurs/:${RouteParam.SubjectResource}`,
    param: RouteParam.SubjectResource,
    component: SubjectResourcePage,
    meta: { requiresAuth: true }
  },
  ResourceGuide: {
    name: 'Ressursveiledning',
    path: `/fag/:${RouteParam.Subject}/tema/:${RouteParam.Topic}/fagressurs/:${RouteParam.SubjectResource}/laererveiledning/:${RouteParam.ResourceGuide}`,
    param: RouteParam.ResourceGuide,
    component: ResourceGuidePage,
    meta: { requiresAuth: true }
  },
  Design: {
    name: 'Design',
    path: '/design',
    component: DesignPage,
    meta: { title: 'Design' }
  },
  Rights: {
    name: 'Rettigheter',
    path: '/rettigheter',
    component: ContentRightsPage,
    meta: { title: 'Rettigheter' }
  },
  Privacy: {
    name: 'Personvern',
    path: '/personvern',
    component: PrivacyPage,
    meta: { title: 'Personvern' }
  },
  Accessibility: {
    name: 'UU',
    path: '/uu',
    component: AccessibilityPage,
    meta: { title: 'Universell utforming' }
  },
  NotFound: {
    name: 'NotFound',
    path: '/:pathMatch(.*)*',
    component: NotFoundPage,
    meta: { title: t('notFound.title') }
  },
})